import type { ReactNode } from "react";

import type {
  MutatedProduct,
  Product,
  ProductId,
  TranslationKey,
} from "../../../../constants/modelCompareData/types";
import type { StoreId } from "@ubnt/store.core/lib/types";
import { parseFootnotes } from "./parseFootnotes";
import { transformPropertyValues } from "./transformPropertyValues";

export const transformProductForCompare = ({
  product,
  storeId,
  formatMessage,
  additionalProductData,
}: {
  product: Product;
  storeId: StoreId;
  formatMessage?: (message: TranslationKey) => string;
  additionalProductData?: {
    id: `${ProductId}`;
    addToCartButton?: ReactNode;
  }[];
}): MutatedProduct => ({
  ...product,
  propertyValues: transformPropertyValues(
    product.propertyValues,
    formatMessage,
    storeId,
  ),
  ...(additionalProductData?.find((p) => p.id === product.id) || {}),
  footnotes: parseFootnotes(product.footnotes, storeId),
});
